module.exports = __webpack_public_path__ + "static/media/iconPhone.7a9ccdec.svg";